<template>
  <div class="flex">
    <core-tooltip text="Crop">
      <u-button
        :variant="isCropMode ? 'solid' : 'ghost'"
        :color="isCropMode ? 'primary' : 'charcoal'"
        icon="i-ri-crop-2-line"
        class="dark:text-white"
        @click="toggleCropMode"
      />
    </core-tooltip>

    <u-popover>
      <core-tooltip text="Corner rounding">
        <u-button color="charcoal" variant="ghost" icon="i-ri-rounded-corner" class="dark:text-white" />
      </core-tooltip>
      <template #panel>
        <surface-editor-core-slider-input
          v-model="cornerRounding"
          @drag-start="surfaceEditorStore.setSliderDragging(true)"
          @drag-end="surfaceEditorStore.setSliderDragging(false)"
          @commit-updates="surfaceEditorStore.commitUndo()"
          class="p-3"
        >
          <template #label>Corner Rounding</template>
        </surface-editor-core-slider-input>
      </template>
    </u-popover>
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const surfaceEditorStore = useSurfaceEditorStore();
  const {selectedElement, editedElement} = storeToRefs(surfaceEditorStore);
  const content = computed(() => selectedElement.value.content);

  const isCropMode = computed(() => editedElement.value?.id === selectedElement.value?.id);

  const cornerRounding = computed({
    get() {
      return content.value.rounding;
    },
    set(rounding) {
      surfaceEditorStore.updateElement({
        element: selectedElement.value,
        updates: {
          content: {rounding}
        },
        commit: false
      });
    }
  });

  function toggleCropMode() {
    surfaceEditorStore.editElement({element: isCropMode.value ? null : selectedElement.value});
  }

  onUnmounted(() => {
    surfaceEditorStore.closeContextualPanel();
  });

</script>
